import { createSlice } from '@reduxjs/toolkit'

const initialState = {
}

export const userSlice = createSlice({
          name:'auth',
          initialState,
          reducers:{ 
            setOfficeId: (state, action) => {
      state.officeId = action.payload;
    },
          },

          extraReducers:(builder)=>{
           
         }
})


export const {saveLoginData,setOfficeId} = userSlice.actions
export default userSlice.reducer
